import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL_CUSTOMER,  
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Oc-Merchant-Id': process.env.VUE_APP_MERCHANT_ID
  },
  timeout: 60000
})

export default {
  async exists(emails) {
    return await apiClient.post('/exists',{
        email_list: emails
    });
  },
  async sendOtp(mobile_number) {
    return await apiClient.post('/sendOtp',{
        mobile_number: mobile_number
    });
  },
  async confirmOtp(mobile_number, otp, action) {
    return await apiClient.post('/confirmOtp',{
        mobile_number: mobile_number,
        otp: otp,
        action: action
    });
  },
  async completeAccount(mobile_number, otp, order_id, username, password) {
    return await apiClient.post('/completeAccount',{
        mobile_number: mobile_number,
        otp: otp,
        order_id: order_id,
        username: username,
        password: password
    });
  },
  async isBlackListed(email, telephone, id_number) {    
    return await apiClient.post('/blacklisted', { 
      email: email,
      telephone: telephone,
      id_number: id_number
    });    
  },
}